import { render } from "./MainStudent.vue?vue&type=template&id=4a0b0c74&ts=true"
import script from "./MainStudent.vue?vue&type=script&lang=ts"
export * from "./MainStudent.vue?vue&type=script&lang=ts"

import "./MainStudent.vue?vue&type=style&index=0&id=4a0b0c74&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__